// 测试服务器
//const baseURL = "https://leica.douaicha.com"
// 阿里服务器
const baseURL = "https://www.lciglobalid.com"
// 本地服务器
 //const baseURL = "http://127.0.0.1:8001"
export default {
    baseURL
  }


// WEBPACK FOOTER //
// ./src/Common.js